import { UserWithRole } from '@wove/api/types'
import UserRow from './UserRow'

interface UsersTableProps {
  users: UserWithRole[]
}

const UsersTable = ({ users }: UsersTableProps) => {
  return (
    <div className="space-y-4">
      {users.map((user) => {
        return <UserRow key={user.id} member={user} changeRole={() => undefined} />
      })}
    </div>
  )
}

export default UsersTable
